export default {
  data: {
    //所在城市
    province_code: "",
    province_name: "",
    city_code: "",
    city_name: "",
    addressFull: "",
    //其他
    account: "",
    code: "",
    password: "",
    repassword: "",
    token: "",
  },
  //type(reg正则验证,Empty验证为空,MinMax验证数量区间)
  rule: {
    account: {
      type: "tel",
      message: "请输入11位手机号码",
    },
    code: {
      type: "reg",
      rule: /^\d{4}$/,
      message: "验证码只能是4位数字",
    },
    token: {
      type: "Empty",
      message: "验证码异常，请重新获取验证码",
    },
  },
};
